<template>
  <div>
    <v-row>
      <v-col cols="12" v-if="$vuetify.breakpoint.mdAndUp">
        <v-card flat class="rounded-lg mt-5 primary--text">
          <v-row class="text-start">
            <v-col cols="7">
              <span class="ms-3">{{ $t("quiz.quiz") }}</span>
            </v-col>

            <v-col cols="5">
              <span>{{ $t("course.createdBy") }}</span>
            </v-col>
          </v-row>
        </v-card>
      </v-col>

      <v-col cols="12">
        <v-row v-if="loading && !data.length">
          <v-col cols="12" class="my-16">
            <v-progress-circular indeterminate color="primary">
            </v-progress-circular>
          </v-col>
        </v-row>

        <v-row v-else-if="!loading && data.length">
          <v-col cols="12" v-for="(quiz, index) in data" :key="index">
            <AvailableQuizCard
              :quiz="quiz"
              @quizzesListReRender="$emit('quizzesReRender')"
            />
          </v-col>
        </v-row>

        <v-row
          v-else-if="!loading && !data.length"
          class="textLight--text font-weight-medium"
          align="center"
        >
          <v-col cols="12">
            {{ $t("noItems") }}
          </v-col>
        </v-row>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import AvailableQuizCard from "./AvailableQuizCard.vue";

export default {
  name: "AvailableQuizList",
  components: { AvailableQuizCard },
  props: {
    data: {
      type: Array,
    },
    loading: {
      default: false,
      type: Boolean,
    },
  },
};
</script>
